import { render, staticRenderFns } from "./ListDeletedFolders.vue?vue&type=template&id=cff8a1f6&"
import script from "./ListDeletedFolders.vue?vue&type=script&lang=ts&"
export * from "./ListDeletedFolders.vue?vue&type=script&lang=ts&"
import style0 from "./ListDeletedFolders.vue?vue&type=style&index=0&id=cff8a1f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports